import { RegionBehaviour } from './RegionBehaviour';
import { BehaviourConfig } from '../../managers/ScrollBehaviourManager';
import { Events } from 'core/events/Events';
import { UIThemeChangeEvent } from 'app/events/UIThemeChangeEvent';
import { SidebarChangeEvent } from 'app/events/SidebarChangeEvent';
import { UIThemeColourType } from 'app/data/Enums';

enum ActionType {
	UI_THEME = 'ui-theme',
	SIDEBAR = 'sidebar'
}

/** @class Scroll behaviour class, trigers when a element goes into a 'region' */
export class IntersectBehaviour extends RegionBehaviour {
	private _intersected: boolean = false;
	private _target: HTMLElement;
	private _targetRect: DOMRect;
	private _calculateScrollCounter: number = 1;

	constructor(
		protected _config: BehaviourConfig,
		protected _container: HTMLElement
	) {
		super(_config, _container);
		this._target = document.querySelector(this._config.selector);

		//TEST VALID. IF not then destroy this
		if (this._testValidElements()) {
			this.resize();
		} else {
			this.destroy();
		}
	}

	public destroy(): void {
		super.destroy();
	}

	public resize(): void {
		this._targetRect = this._target.getBoundingClientRect() as DOMRect;
		super.resize();
	}

	/** Update the scroll position (Note this doesn't nessary mean the 'viewport' is scrolled (but it could))
	 * @param {number} scroll
	 */
	public update(scroll: number): void {
		if (!this._config) {
			return;
		}

		super.update(scroll);

		//getBoundingClientRect is expensive, so limit with a counter
		this._updateRegionRect();

		if (!this._intersected && this._isIntersected()) {
			this._onIntersect();
		} else if (this._intersected && !this._isIntersected()) {
			this._onExitIntersect();
		}
	}

	//PRIVATE
	//----------------------------------------------------------------------------------------------------
	private _onIntersect(): void {
		//When intersected then fire that event:
		if (this._config.action === ActionType.UI_THEME) {
			Events.dispatch(
				new UIThemeChangeEvent({
					theme: this._config.data as UIThemeColourType
				})
			);
		} else if (this._config.action === ActionType.SIDEBAR) {
			let dataParts: Array<string> = this._config.data.split(',');
			Events.dispatch(
				new SidebarChangeEvent({
					theme: dataParts[0] as UIThemeColourType,
					index: parseInt(dataParts[1], 10)
				})
			);
		}

		this._intersected = true;
	}

	private _onExitIntersect(): void {
		this._intersected = false;
		Events.dispatch(
			new UIThemeChangeEvent({
				theme: UIThemeColourType.DARK
			})
		);
	}

	/** Update the region client rect on on a counter so its not 60FPS!! */
	private _updateRegionRect(): void {
		this._calculateScrollCounter++;
		if (this._calculateScrollCounter >= 1) {
			this._regionRect = this._region.getBoundingClientRect() as DOMRect;

			this._calculateScrollCounter = 0;
		}
	}

	/** Check if the target and the region are intersected
	 * https://stackoverflow.com/questions/12066870/how-to-check-if-an-element-is-overlapping-other-elements
	 */
	private _isIntersected(): boolean {
		return !(
			this._regionRect.right < this._targetRect.left ||
			this._regionRect.left > this._targetRect.right ||
			this._regionRect.bottom < this._targetRect.top ||
			this._regionRect.top > this._targetRect.bottom
		);
	}

	/** Test if the elements are valid */
	private _testValidElements(): boolean {
		if (!this._target) {
			try {
				throw new Error(`Behaviour intersect target is not valid  : ${JSON.stringify(this._config)}`);
			} catch (e) {
				console.log(e);
			}
			return false;
		}

		return true;
	}
}
